import React, { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { useLang } from '~/hooks/useLang';

interface FilterSwitchCoordinationProps {
    readonly onCheckedChange: (value: boolean) => void;
    readonly checked: boolean;
    readonly disabled?: boolean
}

export default function FilterSwitchOtherDispatchsGroup({ onCheckedChange, checked, disabled }: FilterSwitchCoordinationProps) {
    const { translate } = useLang();
    const [isChecked, setIsChecked] = useState<boolean>(false);

    useEffect(() => {
        setIsChecked(checked)
    }, [checked])


    return (
        <FormControlLabel
            label={translate('Remove occurrence solved by other dispatch groups')}
            control={
                <Switch
                    disabled={disabled}
                    checked={isChecked}
                    onChange={(_, checked) => {
                        setIsChecked(checked)
                        onCheckedChange(checked)
                    }}
                />
            }
        />
    )
}